import { render, staticRenderFns } from "./nodalPointDetail.vue?vue&type=template&id=a16c6280&scoped=true"
import script from "./nodalPointDetail.vue?vue&type=script&lang=js"
export * from "./nodalPointDetail.vue?vue&type=script&lang=js"
import style0 from "./nodalPointDetail.vue?vue&type=style&index=0&id=a16c6280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16c6280",
  null
  
)

export default component.exports